import { dropdownTriggerClassname } from "app/components/Dropdown";
import { UserIcon } from "app/components/Icons";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import { filterActiveTeamMembers } from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  assignedTo: string;
  onUpdate: (value: string) => void;
}

const AssigneeDropdown: React.FC<Props> = ({
  onUpdate,
  assignedTo,
}) => {
  const members = useSelector(selectProjectMemberList);
  const activeTeamMembers = filterActiveTeamMembers(members);

  const updateValue = (data: IMemberList) => {
    // update form out side parent component
    onUpdate(data._id);
  };
  return (
    <MemberSelection
      trigger={
        <button
          className={clsx(
            "flex items-center justify-between w-full px-2 py-2 rounded ",
            dropdownTriggerClassname,
          )}
        >
          <span className="flex gap-2 text-xs text-secondary">
            <UserIcon size={18} color="#79808A" />
            Assignee:
          </span>
          {assignedTo ? (
            <MemberProfileAvatar
              id={assignedTo}
              containerClassName=" !w-fit "
              circleClassName=" !size-6 "
            />
          ) : (
            "-"
          )}
        </button>
      }
      align="end"
      selectedValue={assignedTo}
      updateValue={updateValue}
      searchPlaceholder="Search by user name"
      className="min-w-[270px]"
      options={activeTeamMembers}
    />
  );
};

export default AssigneeDropdown;
